import React from 'react';
import {ButtonPriority} from '@wix/wix-ui-tpa';
import {classes} from './CheckoutButton.st.css';
import classnames from 'clsx';
import {useControllerProps} from '../../../domain/controllers/ControllerContext';
import {StatesButtonStates, ThreeDotsLoader, StatesButton} from '@wix/wix-ui-tpa/cssVars';
import {SECURE_CHECKOUT_ID} from '../SecureCheckout/SecureCheckout';

export enum CheckoutButtonDataHook {
  button = 'CheckoutButtonDataHook.button',
  threeDotsLoader = 'CheckoutButtonDataHook.threeDotsLoader',
}

export interface CheckoutButtonProps {
  disabled?: boolean;
  priority?: ButtonPriority;
  text: string;
  isNavigationToCheckoutInProcess?: boolean;
  className?: string;
}

export function CheckoutButton({
  disabled,
  priority,
  text,
  isNavigationToCheckoutInProcess,
  className,
}: CheckoutButtonProps) {
  const {handleCheckoutButtonClick, handleCheckoutButtonHover} = useControllerProps().navigationStore;

  return (
    <StatesButton
      aria-labelledby={SECURE_CHECKOUT_ID}
      priority={priority}
      className={classnames(classes.customizableCheckoutButton, className)}
      data-hook={CheckoutButtonDataHook.button}
      data-wix-checkout-button={CheckoutButtonDataHook.button}
      disabled={disabled}
      state={isNavigationToCheckoutInProcess ? StatesButtonStates.IN_PROGRESS : StatesButtonStates.IDLE}
      onClick={() => {
        return handleCheckoutButtonClick();
      }}
      onMouseEnter={() => {
        return handleCheckoutButtonHover();
      }}
      inProgressContent={
        <ThreeDotsLoader data-hook={CheckoutButtonDataHook.threeDotsLoader} className={classes.threeDotButton} />
      }
      idleContent={text}
      upgrade
    />
  );
}
